const DEV = false; // Set to false before deploying to production
export const API_BASE_URL = DEV
  ? "http://localhost:5001"
  : "https://munazem-api.onrender.com";
